<template>
  <div
    class="block-ui d-flex align-center justify-center"
    id="app--block-ui"
    role="alert"
  >
    <div class="loading-spinner d-flex flex-column align-center justify-center">
      <v-progress-circular
        v-bind="$attrs"
        v-on="$listeners"
        :size="size"
        :width="width"
        :color="colour"
        :indeterminate="indeterminate"
        :aria-label="text"
      />
      <div class="mt-4 block-ui--loading-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockUI',
  props: {
    size: {
      type: [Number, String],
      default: '70'   // override the default value '32' in v-progress-circular
    },
    width: {
      type: [Number, String],
      default: '6'   // override the default value '4' in v-progress-circular
    },
    colour: {
      type: String,
      default: 'primary'   // override the default value 'undefined' in v-progress-circular
    },
    text: {
      type: String,
      default: 'Loading...'
    },
    indeterminate: {
      type: Boolean,
      default: true   // override the default value 'false' in v-progress-circular
    }
  }
}
</script>

<style lang='scss' scoped>
@import "../../styles/variables.scss";

div.block-ui {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  z-index: 900;
  background-color: rgba(0, 0, 0, 0.15);
}

div.block-ui .loading-spinner {
  width: 180px;
  height: 190px;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.9);
}

div.block-ui .block-ui--loading-text {
  color: $ads-dark-60;
}
</style>
